import { useMutation } from 'Data/Api'
import {
  notifyError,
  notifySuccess,
  useNotifications,
} from 'Logic/Notifications.js'
import { useDataValue, useDataSubmit } from 'Simple/Data.js'

import mutation from './mutation.graphql.js'

/** @type {import('Simple/types.js').useDataOnSubmit} */
export default function useDataOnSubmit(props, data, reExecuteQuery) {
  let [, notify] = useNotifications()
  let submit = useDataSubmit({
    viewPath: props.viewPath,
    context: 'has_unaknowledged_tokens',
  })
  let account_id = useDataValue({
    viewPath: props.viewPath,
    context: 'provider_account',
    path: 'account_id',
  })
  let [, executeMutation] = useMutation(mutation)

  return async function onSubmit({ value, originalValue, args, change }) {
    let mutationResponse = await executeMutation({
      account_id,
    })
    if (mutationResponse.error) {
      notify(notifyError('Something went wrong. Please try again.'))
      return
    }

    notify(notifySuccess('Job created successfully.'))

    submit({ type: 'reFetch' })
  }
}
